import React from 'react';
import GenerationHistory from '../components/GenerationHistory';
export default function Library() { return <GenerationHistory library />; }
